import React from "react";
import ReactDOM from "react-dom";
import Auth from "@aws-amplify/auth";
import debug from "debug";
import credentials from "./aws-exports";
import { AuthProvider } from "context/auth";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import { icons } from "assets/icons";
React.icons = icons;
Auth.configure(credentials);

if (process.env.REACT_APP_DEBUG) {
  debug.enable(process.env.REACT_APP_DEBUG);
  // eslint-disable-next-line no-console
  debug.log = console.log.bind(console);
}

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
